var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQoutesRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quote_4338295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 370",
    d: "M8.45315 19.0609C7.44672 21.4869 6.03153 23.7224 4.26915 25.6699C3.9786 25.9959 3.80274 26.408 3.76844 26.8434C3.73413 27.2787 3.84325 27.7134 4.07915 28.0809C4.25694 28.3651 4.50464 28.599 4.79858 28.7603C5.09252 28.9215 5.4229 29.0047 5.75815 29.0019C5.95103 29.0086 6.14361 28.9816 6.32715 28.9219C10.3091 27.7559 19.6131 23.6219 19.8691 10.3799C19.9477 7.95551 19.1206 5.58878 17.5492 3.74098C15.9778 1.89318 13.7746 0.696745 11.3691 0.384872C10.044 0.243657 8.70391 0.383017 7.43614 0.793883C6.16837 1.20475 5.00131 1.87792 4.01088 2.76959C3.02044 3.66126 2.22883 4.75147 1.68754 5.96927C1.14624 7.18707 0.867401 8.50519 0.869149 9.83787C0.866647 12.0164 1.62196 14.128 3.00563 15.8107C4.38931 17.4934 6.31517 18.6424 8.45315 19.0609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 371",
    d: "M32.9811 0.384883C31.6571 0.245902 30.3188 0.386944 29.053 0.79885C27.7871 1.21076 26.622 1.88431 25.6334 2.77578C24.6448 3.66725 23.8548 4.75669 23.3146 5.97336C22.7745 7.19002 22.4963 8.5067 22.4981 9.83788C22.4956 12.0164 23.2509 14.128 24.6345 15.8107C26.0182 17.4934 27.9441 18.6424 30.0821 19.0609C29.0753 21.487 27.6598 23.7224 25.8971 25.6699C25.6065 25.9959 25.4307 26.4081 25.3963 26.8434C25.362 27.2788 25.4712 27.7134 25.7071 28.0809C25.8848 28.3651 26.1325 28.599 26.4265 28.7603C26.7204 28.9215 27.0508 29.0047 27.3861 29.0019C27.5793 29.0088 27.7722 28.9817 27.9561 28.9219C31.9381 27.7569 41.2421 23.6219 41.4991 10.3809V10.1909C41.5317 7.79539 40.6813 5.47173 39.11 3.66326C37.5387 1.8548 35.3566 0.688135 32.9801 0.385884L32.9811 0.384883Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoutesRight);
export default __webpack_public_path__ + "static/media/qoutes-right.99bd0419f0f195188f60baaad7569409.svg";
export { ForwardRef as ReactComponent };